import {dashV2Path} from 'components/StatsPage2.utils';

const orderedProps = [
  {
    urlPart: 'admin',
    prop: 'adminId',
  },
  {
    urlPart: 'manager',
    prop: 'managerId',
  },
  {
    urlPart: 'rep',
    prop: 'repId',
  },
  {
    urlPart: 'coach',
    prop: 'coachId',
  },
];

export default function buildUrl(props) {
  return (
    `/${dashV2Path}` +
    orderedProps
      .map(({prop, urlPart}) => props[prop] && `/${urlPart}/${props[prop]}`)
      .filter(part => !!part)
      .join('')
  );
}
